import { useEffect, useState } from 'react';

import { PEER_GONE_CLOSING_SECONDS } from '@/common/utils/oralExam/oneToOnePeerGone';

/**
 * 30s closing countdown for last-question peer-gone. Resets when peer returns
 * or when the closing window is not active. Hitting 0 keeps the banner (S2
 * wires the complete mutation).
 */
export function usePeerGoneClosingCountdown(
  peerGone: boolean,
  isLastQuestion: boolean,
): { secondsRemaining: number; showClosingCountdown: boolean } {
  const showClosingCountdown = peerGone && isLastQuestion;
  const [secondsRemaining, setSecondsRemaining] = useState(PEER_GONE_CLOSING_SECONDS);

  useEffect(() => {
    if (!showClosingCountdown) {
      setSecondsRemaining(PEER_GONE_CLOSING_SECONDS);
      return undefined;
    }

    setSecondsRemaining(PEER_GONE_CLOSING_SECONDS);
    const tick = () => {
      setSecondsRemaining((prev) => (prev <= 0 ? 0 : prev - 1));
    };
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [showClosingCountdown]);

  return { secondsRemaining, showClosingCountdown };
}
